import { rem, TextProps, Title as Text } from 'affiny-ui/src';
import React from 'react';

interface IPersonalityReportLayerTitle extends Omit<TextProps, 'color'> {
  isPrimary?: boolean;
  children: string;
  id?: string;
}

export const PersonalityReportLayerTitle = ({
  isPrimary = false,
  children,
  id,
  ...rest
}: IPersonalityReportLayerTitle) => {
  return (
    <Text
      color="primary"
      fontSize={isPrimary ? rem(30) : rem(24)}
      mb="xLarge"
      id={id}
      {...rest}
    >
      {children}
    </Text>
  );
};
